// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2QbH0","list":"PatternAutocomplete_list__2bPDV"};